import { useSuspenseQuery } from '@tanstack/react-query';

import { accessorialDetailsQueryOptions } from '../data-provider';
import type { AccessorialDetailsParams } from '../models';

export const useSuspenseAccessorialDetails = (params: AccessorialDetailsParams) =>
  useSuspenseQuery(accessorialDetailsQueryOptions(params));
